<template>
  <div class="register">
     <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>

    <v-registerTop :navTitle="navTitle"  :webConfigInfo='webConfigInfo'></v-registerTop>
    <!-- <div class="setNavBg">
      <v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo' ></v-header>
    </div> -->
    <div class="registerStepTit"><h3>{{titleName}}</h3></div>
    <div class="registerStepCon">
      <el-steps :active="0" align-center>
        <el-step title="1 填写企业信息"></el-step>
        <el-step title="2 完善个人信息"></el-step>
        <el-step title="3 提交审核"></el-step>
        <el-step title="4 完成注册"></el-step>
      </el-steps>
      <div class="formCon">
        <h5>该企业已注册</h5>
        <el-form :model="baseInforRuleForm" :rules="baseInforRules" ref="supplierRuleForm" label-width="160px" class="demo-ruleForm">
          <el-form-item label="企业名称">
            {{baseInforRuleForm.orgName}}
          </el-form-item>
          <el-form-item label="审核状态">
            <div class="orgStatus-btn-cont">
              <el-button class="orgStatus-btn-25" v-if="orgStatus==25">审核驳回</el-button>
              <el-button class="orgStatus-btn-30" v-if="orgStatus==30">已审核</el-button>
              <el-button class="orgStatus-btn-1020" v-if="orgStatus==10||orgStatus==20">审核中</el-button>
            </div>
            <div class="orgStatus-text-1020" v-if="orgStatus==10||orgStatus==20">当前企业注册审核中，请您耐心等待。审核通过后，才可以入驻到该企业。</div>
            <div class="orgStatus-text-25" v-if="orgStatus==25">当前企业注册审核已被驳回。请通知注册人（{{currentTrueName||linkMan}}：{{currentEmail||orgEmail}}） 登录后重新编辑并提交，审核通过后，才可入驻到该企业。</div>
          </el-form-item>
          <el-form-item label="企业授权函" prop="authFileUrl">

            <div class="downCon">
              <el-button  v-if="orgStatus!=30" class="disable-btn">下载企业授权委托模板</el-button>
              <el-button v-else @click="viewAttachment(authorizationUrl)">下载企业授权委托模板</el-button>
              <p>请下载企业授权委托模板并填写，填写完成后盖章并上传扫描件。</p>
            </div>
           <div class="control-con">
           <div class="upBtn downCon"  v-if="orgStatus!=30">
              <el-button class="disable-btn">上传附件</el-button>
           </div>
           <div class="upBtn" v-else>
            <input type="file" id="authFile" name="authFile" ref="authFile" @change="tirggerAuthFile($event)" multiple>
             <input class="btn btn-default" type="button" value="上传附件" >
           </div>
           <a href="#" class="filesList" @click="viewAttachment(baseInforRuleForm.authFileUrl)" v-if="showAuthFlag">{{baseInforRuleForm.authFileName}}</a>&nbsp;&nbsp;&nbsp;&nbsp;<a href="JavaScript:void(0)" @click="deleteAuthFile()" v-if="showAuthFlag">删除</a>
        </div>
        <div slot="tip" class="el-upload__tip">请上传企业授权函加盖公章，上传文件不得超过10M</div>
          </el-form-item>
          <el-form-item class="btnCon">
            <el-button @click="back()">上一步</el-button>
            <el-button type="primary" v-if="orgStatus!=30" class="disable-btn">继续</el-button>
            <el-button type="primary" v-else @click="submitForm('supplierRuleForm')">继续</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' ></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import registerTop from '@/components/registerTop'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  import { mapState } from 'vuex'
  import {customCompanyInformation} from '@/assets/js/sensors'

  export default {
    props: [],
    data () {
      return {
        navigationColumnInfos: [],
        navTitle:'注册',
        authorizationUrl:'',
        bannerInfo: {title: '信息完善',content: "Information perfection"},
        webConfigInfo: {},
        footerColumnInfos:[],
        baseInforRuleForm: {
          authFileUrl:'',
          authFileName:'',
          authFileKey:'',
          authFile:{},
          id:'',
          orgName:'',
          orgIdentity:'',
          regAddrType:'',
          licenceCode:''
        },
        showAuthFlag:false,
        baseInforRules: {
          authFileUrl: [
            { required: true, message: '请选择企业授权函', trigger: 'blur' }
          ]
        },
        requestCompanyInfo:{},
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        selectOrgIdentity:'',
        titleName:'',
        requestCompanyInfoExt:{},
        
        orgStatus:null,//待验证10 待审核20 审核驳回25 已验证30 
        
        currentTrueName:null,//缓存企业注册人
        currentEmail:null,//缓存企业注册邮箱
        
        linkMan:'',//企业注册人
        orgEmail:'',//企业注册邮箱
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-registerTop': registerTop,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    computed: mapState([
      'KP'
    ]),
    created () {

      let query = this.$route.query;
      this.email  = query.email;
      this.companyId = query.companyId;
      this.companyName = query.companyName;
      this.orgIdentity = query.orgIdentity;
      this.regAddrType = query.regAddrType;
      this.userId = query.userId;
      this.regeisterType = query.regeisterType;
      if(typeof(this.companyId) == "undefined"){
        this.regeisterInfo = JSON.parse(this.getDAesString(this.getToken('regeisterInfo'),this.KP.key,this.KP.iv));
        // console.info(this.regeisterInfo)
        // 设置企业审批核状态，企业注册人，注册邮箱
        if(this.regeisterInfo&&this.regeisterInfo.orgStatus){
          this.orgStatus=this.regeisterInfo.orgStatus
        }
        this.currentTrueName = this.regeisterInfo.currentTrueName;
        this.currentEmail = this.regeisterInfo.currentEmail;
        this.requestCompanyInfoExt = this.regeisterInfo.requestCompanyInfo;
        if (typeof(this.requestCompanyInfoExt) != "undefined" ){
          this.baseInforRuleForm.authFileUrl = this.requestCompanyInfoExt.authFileUrl;
          this.baseInforRuleForm.authFileName = this.requestCompanyInfoExt.authFileName;
        }
        if(this.baseInforRuleForm.authFileUrl !=''){
          this.showAuthFlag = true;
        }else{
          this.showAuthFlag = false;
        }

        this.baseInforRuleForm.orgName = this.regeisterInfo.companyName;
        this.baseInforRuleForm.orgIdentity = this.regeisterInfo.orgIdentity;

        this.baseInforRuleForm.regAddrType = this.regeisterInfo.regAddrType;
        this.baseInforRuleForm.id = this.regeisterInfo.companyId;
        this.baseInforRuleForm.licenceCode = this.regeisterInfo.licenceCode;
      }else{
        this.baseInforRuleForm.orgName = this.companyName;
        this.baseInforRuleForm.orgIdentity = this.orgIdentity;

        this.baseInforRuleForm.regAddrType = this.regeisterType;
        this.baseInforRuleForm.id = this.companyId;
      }

      this.selectOrgIdentity  = this.baseInforRuleForm.regAddrType;
      if(this.selectOrgIdentity == '20'){
        this.titleName = '采购商注册';
      }
      if(this.selectOrgIdentity == '10'){
        this.titleName = '供应商注册';
      }
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.authorizationUrl = this.data.authorizationUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
        if(typeof(this.companyId) != "undefined"){
          this.baseInforRuleForm.authFileUrl = this.data.authFileUrl;
          this.baseInforRuleForm.authFileName = this.data.authFileName;

          if(this.baseInforRuleForm.authFileUrl !=''){
            this.showAuthFlag = true;
          }else{
            this.showAuthFlag = false;
          }
        }
        if(this.getToken('regeisterInfo')!=''){
          this.regeisterInfo = JSON.parse(this.getDAesString(this.getToken('regeisterInfo'),this.KP.key,this.KP.iv));
          // console.info(this.regeisterInfo)
          // 设置企业审批核状态，企业注册人，注册邮箱
          if(this.regeisterInfo&&this.regeisterInfo.orgStatus){
            this.orgStatus=this.regeisterInfo.orgStatus
          }
          this.currentTrueName = this.regeisterInfo.currentTrueName;
          this.currentEmail = this.regeisterInfo.currentEmail;
          this.requestCompanyInfoExt = this.regeisterInfo.requestCompanyInfo;
          if (typeof(this.requestCompanyInfoExt) != "undefined" ){
            this.baseInforRuleForm.authFileUrl = this.requestCompanyInfoExt.authFileUrl;
            this.baseInforRuleForm.authFileName = this.requestCompanyInfoExt.authFileName;
          }
          if(this.baseInforRuleForm.authFileUrl !=''){
            this.showAuthFlag = true;
          }else{
            this.showAuthFlag = false;
          }
        }



        // if (typeof(this.requestCompanyInfoExt) != "undefined" && typeof(this.companyId) != "undefined"){
        //   if (typeof(this.requestCompanyInfoExt) != "undefined" ){
        //     this.baseInforRuleForm.authFileUrl = this.requestCompanyInfoExt.authFileUrl;
        //     this.baseInforRuleForm.authFileName = this.requestCompanyInfoExt.authFileName;
        //   }
        //   if(this.baseInforRuleForm.authFileUrl !=''){
        //     this.showAuthFlag = true;
        //   }else{
        //     this.showAuthFlag = false;
        //   }
        // }
      }).catch((err) => {
        console.log(err)
      })

    },
    mounted () {
      
      // 查询企业审批核状态，企业注册人，注册邮箱
      // 针对审核驳回跳转过来的，没有企业审批核状态，企业注册人，注册邮箱
      if(this.companyId){
          
        this.$axios.post('/onelink.mdata.main.api/company/findOrgInformation', {
          companyId:this.companyId
        }).then((res) => {
          console.info(res)
          this.orgStatus=res.data.data.companyInfo.orgStatus
          this.linkMan=res.data.data.companyInfo.uCenterOrgContactInfoDto.linkMan
          this.orgEmail=res.data.data.companyInfo.uCenterOrgContactInfoDto.orgEmail
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    methods: {
      submitForm(formName) {
        this.$refs['supplierRuleForm'].validate((valid) => {
          if (valid) {
            this.requestCompanyInfo.id=this.baseInforRuleForm.id;
            this.requestCompanyInfo.orgName=this.baseInforRuleForm.orgName;
            this.requestCompanyInfo.userTag = this.baseInforRuleForm.orgIdentity;
            this.requestCompanyInfo.orgIdentity=this.baseInforRuleForm.orgIdentity;
            this.requestCompanyInfo.regAddrType=this.baseInforRuleForm.regAddrType;
            this.requestCompanyInfo.authFileName = this.baseInforRuleForm.authFileName;
            this.requestCompanyInfo.authFileUrl = this.baseInforRuleForm.authFileUrl;
            this.requestCompanyInfo.licenceCode = this.baseInforRuleForm.licenceCode;
            this.setToken('requestCompanyInfo', this.getAesString(JSON.stringify(this.requestCompanyInfo),this.KP.key,this.KP.iv));
            this.setToken('regeisterType','user');
            if(this.email !=''){
              this.$router.push({path: '/registerUserInfo',query:{userId:this.userId,email:this.email,companyId:this.companyId,companyName:this.companyName,orgIdentity:this.orgIdentity,regAddrType:this.regAddrType}})
            }else{
              this.$router.push({path: '/registerUserInfo'})
            }

            // 埋点
            try {
              customCompanyInformation({
                org_id: this.requestCompanyInfo.id,
                org_name: this.requestCompanyInfo.orgName,
                is_first_time: false
              })
            } catch (e) {console.log(e)}
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      goToHref(val){
        this.$router.push({path: val})
      },
      tirggerAuthFile(event){
         if(this.baseInforRuleForm.authFileUrl!=''){
          this.$message({
                message: "您已上传附件，若您需要更新附件，请先删除原附件",
                type: 'error'
          });
          return false;
        }
        let file = event.target.files[0];
        let fileName = String(file.name);
        let fileSize = file.size;
        var AllImgExt=".jpg|.jpeg|.png|.pdf|";
        var extName = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
        if(AllImgExt.indexOf(extName+"|")==-1){
          this.$message({
                message: "仅支持JPG、JPEG、PNG、PDF格式",
                type: 'error'
          });
          return false;
        }
        if(fileSize/1024/1024 >10){
          this.$message({
                message: "文件小于10M",
                type: 'error'
          });
          return false;
        }
        this.baseInforRuleForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
          this.baseInforRuleForm.authFileName = this.data.fileName;
          this.baseInforRuleForm.authFileUrl = this.data.fileKey;
          this.baseInforRuleForm.authFileKey = this.data.fileKey;
          this.$refs['supplierRuleForm'].validate((valid) => {});
          this.showAuthFlag = true;
        }).catch((err) => {
          console.log(err)
        })
      },
      deleteAuthFile(){
        this.baseInforRuleForm.authFileName = '';
        this.baseInforRuleForm.authFileUrl = '';
        this.baseInforRuleForm.authFileKey = '';
        this.$refs.authFile.value= '';
        this.$refs['supplierRuleForm'].validate((valid) => {});
        this.showAuthFlag = false;
      },
      viewAttachment(url){
        if(url.indexOf("http")!=-1){
          window.location.href=url;
        }else{
          this.$axios.get('/onelink.mdata.main.api/upload/getDownloadURL?fioleKey='+url, {
          }).then((res) => {
            this.data = res.data;
            window.location.href=this.data;
          }).catch((err) => {
            console.log(err)
          })
        }

      },
      back(){
        this.$router.push({path:'/register'})
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/registerExistBusinessInfo/index.vue